import { ITheme } from "../../utils/theme";

export const tableWrapper = {
  background: (theme: ITheme) => theme.palette.grey[600],
  paddingTop: 2,
  paddingBottom: 2,
  paddingRight: 1,
  paddingLeft: 1,
  marginTop: 1,
  marginBottom: 4,
  overflow: 'auto',
  borderRadius: '5px'
}

export const dispatchInfoTableStyle = (theme: ITheme) => ({
  '.MuiTableHead-root .MuiTableCell-root': {
    background: theme.palette.blue[600],
    color: 'white',
    textAlign: 'center',
    ' .MuiTypography-root': {
      fontFamily: theme.typography.fontFamily,
      fontSize: '18px',
    },
  },
  '.MuiTableBody-root .MuiTableRow-root': {
    background: theme.palette.common.white,
    '&:nth-of-type(even)': {
      background: theme.palette.blue[100]
    },
    '&:nth-of-type(1)': {
      background: theme.palette.blue[300],
      ' .MuiTypography-root': {
        fontFamily: theme.typography.fontFamily,
        fontSize: '18px',
      },
    },
    ' .MuiTableCell-root': {
      borderRight: `1px solid ${theme.palette.grey[300]}`,
      pt: 1,
      pb: 1
    }
  }
})

export const boldText = {
  fontWeight: 'bold'
}

export const paginationStyles = {
  padding: 0,
  py: 1,
  display: 'flex',
  justifyContent: 'center',
  position: 'sticky',
  left: 0,
  width: 'inherit !important',
  '& .MuiPagination-ul': {
    justifyContent: 'center',
  },
}

export const halfWidth = {
  width: '50%'
}

export const NoRecordsStyle = (theme: ITheme) => ({
  textAlign: 'center',
  padding: 1,
  borderRadius: '10px',
  color: theme.palette.black
});